import { pdfjs } from 'react-pdf';

let workerInitialized = false;

export const ensurePdfJsWorker = () => {
  if (workerInitialized || typeof window === 'undefined') {
    return;
  }

  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  workerInitialized = true;
};
